<ng-container *ngIf="heroData">
  <section class="section padd-t-96 white-100">
    <div class="section-container-inside">
      <div class="align-c">
        <h1 class="product-hero-header grey-800">
          {{ heroData?.header }}
        </h1>
        <h5
          class="revolutionize-team-description mar-t-24"
          [innerHtml]="heroData?.paragraph | toHtml"
        ></h5>
        <div class="wid-50-sub mar-t-48">
          <div id="hubspotComponentForm"></div>
        </div>
      </div>
    </div>
  </section>

  <section class="section white-100">
    <div class="section-container-inside">
      <ng-container *ngFor="let image of heroData.images; let i = index">
        <div class="helping-businesses-container" *ngIf="i === 0">
          <a href="{{ image?.fields?.link }}" target="_blank" rel="noopener noreferrer">
            <div class="view">
              <figure>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="72"
                  height="72"
                  viewBox="0 0 72 72"
                  fill="none"
                >
                  <rect width="72" height="72" rx="36" fill="white" />
                  <g clip-path="url(#clip0_440_52196)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M47.1541 24.8472C46.8251 24.5182 46.3789 24.3334 45.9136 24.3334L30.8534 24.3334C29.8845 24.3334 29.0991 25.1188 29.0991 26.0878C29.0991 27.0567 29.8845 27.8421 30.8534 27.8421L41.6773 27.8421L23.5835 45.936C22.8984 46.6211 22.8984 47.7319 23.5835 48.4171C24.2686 49.1022 25.3795 49.1022 26.0646 48.4171L44.1592 30.3224V41.1479C44.1592 42.1168 44.9447 42.9023 45.9136 42.9023C46.8825 42.9023 47.668 42.1168 47.668 41.1479L47.668 26.0878C47.668 25.6225 47.4831 25.1762 47.1541 24.8472Z"
                      fill="#359EB4"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_440_52196">
                      <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="matrix(1 0 0 -1 16 56)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </figure>
            </div>
            <div class="helping-business-image-container">
              <img
                class="wid-full display-b"
                src="{{ image?.fields?.imageicon?.fields?.file?.url }}"
                alt="{{ image?.fields?.imageicon?.fields?.title }}"
              />
              <div class="helping-businesses-logo-container">
                <figure>
                  <img
                    class="helping-businesses-logo height-logo"
                    src="{{ image?.fields?.iconImage?.fields?.file?.url }}"
                    alt="{{ image?.fields?.iconImage?.fields?.title }}"
                  />
                </figure>
              </div>
            </div>
          </a>
        </div>
      </ng-container>
      <div class="section-customer-story-container">
        <ng-container *ngFor="let image of heroData?.images; let i = index">
          <div
            class="inner-wrapper"
            [ngClass]="{
              'customer-story-one': i === 1,
              'customer-story-two': i === 2,
            }"
            *ngIf="i !== 0"
          >
            <a href="{{ image?.fields?.link }}" target="_blank" rel="noopener noreferrer">
              <div class="view">
                <figure>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="72"
                    height="72"
                    viewBox="0 0 72 72"
                    fill="none"
                  >
                    <rect width="72" height="72" rx="36" fill="white" />
                    <g clip-path="url(#clip0_440_52196)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M47.1541 24.8472C46.8251 24.5182 46.3789 24.3334 45.9136 24.3334L30.8534 24.3334C29.8845 24.3334 29.0991 25.1188 29.0991 26.0878C29.0991 27.0567 29.8845 27.8421 30.8534 27.8421L41.6773 27.8421L23.5835 45.936C22.8984 46.6211 22.8984 47.7319 23.5835 48.4171C24.2686 49.1022 25.3795 49.1022 26.0646 48.4171L44.1592 30.3224V41.1479C44.1592 42.1168 44.9447 42.9023 45.9136 42.9023C46.8825 42.9023 47.668 42.1168 47.668 41.1479L47.668 26.0878C47.668 25.6225 47.4831 25.1762 47.1541 24.8472Z"
                        fill="#359EB4"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_440_52196">
                        <rect
                          width="40"
                          height="40"
                          fill="white"
                          transform="matrix(1 0 0 -1 16 56)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </figure>
              </div>
              <div class="helping-business-image-container">
                <img
                  class="wid-full display-b"
                  src="{{ image?.fields?.imageicon?.fields?.file?.url }}"
                  alt="{{ image?.fields?.imageicon?.fields?.title }}"
                />
                <div class="helping-businesses-logo-container">
                  <figure>
                    <img
                      class="helping-businesses-logo height-logo"
                      src="{{ image?.fields?.iconImage?.fields?.file?.url }}"
                      alt="{{ image?.fields?.iconImage?.fields?.title }}"
                    />
                  </figure>
                </div>
              </div>
            </a>
          </div>
        </ng-container>
      </div>
    </div>
  </section>
</ng-container>
